<script>
import { required, helpers } from "@vuelidate/validators";
import appConfig from "../../../app.config";

import { authMethods } from "@state/helpers";

export default {
  page: {
    title: "Login",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      email: null,
      password: null,
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
    };
  },
  validations: {
    email: {
      required: helpers.withMessage("Email is required", required),
    },
    password: {
      required: helpers.withMessage("Password is required", required),
    },
  },
  computed: {},
  methods: {
    ...authMethods,
    // and password they provided.
    tryToLogIn() {
      this.tryingToLogIn = true;
      this.authError = null;
      return this.logIn({
        applicationId: 1,
        email: this.email,
        password: this.password,
      })
        .then((response) => {
          this.tryingToLogIn = false;
          this.isAuthError = false;
          console.log(response)
          this.$router.push({
            path: "/"
          });
        })
        .catch((error) => {
          this.tryingToLogIn = false;
          this.authError = error.response ? error.response.data.message : "";
          this.isAuthError = true;
        });
    },
  },
};
</script>

<template>
  <div class="auth-page-wrapper pt-5">
    <div class="auth-page-content">
      <b-container>
        <b-row class="justify-content-center">
          <b-col md="8" lg="6" xl="5">
            <b-card no-body class="mt-4">
              <b-card-body class="card-login">
                <img src="@assets/gls-logo/gls-header-logo.png" alt="" width="156" height="59"/>

                <div class="w-100">
                  <b-alert
                    v-model="authError"
                    variant="danger"
                    class="mt-3"
                    dismissible
                    >{{ authError }}</b-alert
                  >

                  <h5>Selamat Datang</h5>

                  <form @submit.prevent="tryToLogIn">
                    <div class="mb-3">
                      <label for="email" class="form-label">Email</label>
                      <input
                        type="text"
                        class="form-control"
                        id="email"
                        placeholder="Enter email"
                        v-model="email"
                      />
                      <div class="invalid-feedback">
                        <span></span>
                      </div>
                    </div>

                    <div class="mb-3">
                      <label class="form-label" for="password-input"
                        >Password</label
                      >
                      <div class="position-relative auth-pass-inputgroup mb-3">
                        <input
                          type="password"
                          v-model="password"
                          class="form-control pe-5"
                          placeholder="Enter password"
                          id="password-input"
                        />
                        <b-button
                          variant="link"
                          class="
                            position-absolute
                            end-0
                            top-0
                            text-decoration-none text-muted
                          "
                          type="button"
                          id="password-addon"
                        >
                          <i class="ri-eye-fill align-middle"></i>
                        </b-button>
                        <div class="invalid-feedback">
                          <span></span>
                        </div>
                      </div>
                    </div>

                    <div class="mt-4">
                      <b-button
                        variant="primary"
                        class="w-100"
                        type="submit"
                        @click="tryingToLogIn"
                      >
                        Sign In
                      </b-button>
                    </div>
                  </form>
                </div>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>
